/* @flow */

import type { $Activity } from '../types/Activity';
import { TemplateMarketPropertyKeys } from '../templates/TemplateMarketProperties';

export const activityTypesGroupCodePrefix = 'ACTIVITY-TYPES-GROUP';
export const activityTypesGroupNamePrefix = 'Activity types group:';
export const activityTypesGroupMatchCodePrefix = 'Activity_types_group';

export const ActivityTypesGroupCodes = {
  ACTIVITY_TYPES_GROUP_EQC_SALES: `${ activityTypesGroupCodePrefix }-EQC-SALES`,
  ACTIVITY_TYPES_GROUP_EQC_AFTER_SALES: `${ activityTypesGroupCodePrefix }-EQC-AFTER-SALES`,
  ACTIVITY_TYPES_GROUP_REPAIR: `${ activityTypesGroupCodePrefix }-REPAIR`,
  ACTIVITY_TYPES_GROUP_JUNGE_STERNE: `${ activityTypesGroupCodePrefix }-JUNGE-STERNE`,
  ACTIVITY_TYPES_GROUP_COMMERCIAL_SALES: `${ activityTypesGroupCodePrefix }-COMMERCIAL-SALES`,
  ACTIVITY_TYPES_GROUP_PRIVATE_SALES: `${ activityTypesGroupCodePrefix }-PRIVATE-SALES`,
};

export const ActivityTypeGroupsMarketPropertyKeys: Map<string, string> = new Map([
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_EQC_SALES,
    ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_EQC_SALES
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_EQC_AFTER_SALES,
    ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_EQC_AFTER_SALES
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_REPAIR,
    ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_REPAIR
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_JUNGE_STERNE,
    ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_JUNGE_STERNE
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_COMMERCIAL_SALES,
    ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_COMMERCIAL_SALES,
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_PRIVATE_SALES,
    ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_PRIVATE_SALES,
  ],
]);

export default ([
  {
    name: `${activityTypesGroupNamePrefix} ECQ sales`,
    code: ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_EQC_SALES,
    matchCode: `${activityTypesGroupMatchCodePrefix}_EQC_sales`
  },
  {
    name: `${activityTypesGroupNamePrefix} ECQ after sales`,
    code: ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_EQC_AFTER_SALES,
    matchCode: `${activityTypesGroupMatchCodePrefix}_EQC_after_sales`
  },
  {
    name: `${activityTypesGroupNamePrefix} Repair`,
    code: ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_REPAIR,
    matchCode: `${activityTypesGroupMatchCodePrefix}_Repair`
  },
  {
    name: `${activityTypesGroupNamePrefix} Junge Sterne`,
    code: ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_JUNGE_STERNE,
    matchCode: `${activityTypesGroupMatchCodePrefix}_Junge_Sterne`
  },
  {
    name: `${activityTypesGroupNamePrefix} Commercial Sales`,
    code: ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_COMMERCIAL_SALES,
    matchCode: `${activityTypesGroupMatchCodePrefix}_Commercial_Sales`
  },
  {
    name: `${activityTypesGroupNamePrefix} Private Sales`,
    code: ActivityTypesGroupCodes.ACTIVITY_TYPES_GROUP_PRIVATE_SALES,
    matchCode: `${activityTypesGroupMatchCodePrefix}_Private_Sales`
  },
]: Array<$Activity>);
